export default __webpack_public_path__ + "static/study-4-mobile-160c548ca34b052d9752dba6483f4872.jpg";